import { GET_ASSETS_ORGANIZATIONS } from 'api'
import { libaryType } from 'interfaces'

export const getQueryKey = (
	type: libaryType,
	userId: string,
	organizationId: string
): string[] => {
	switch (type) {
		case 'contents':
			return [`${GET_ASSETS_ORGANIZATIONS}_CONTENTS`, userId, organizationId]
		case 'locations':
			return [`${GET_ASSETS_ORGANIZATIONS}_LOCATIONS`, userId, organizationId]
		case 'resources':
			return [`${GET_ASSETS_ORGANIZATIONS}_RESOURCES`, userId, organizationId]
		default:
			return [GET_ASSETS_ORGANIZATIONS, userId, organizationId]
	}
}
